/* src/app/shared/components/district-campus-dropdowns/district-campus-dropdowns.component.scss */
.match__messages {
  display: grid;
  grid-template-columns: 29em 29em;
}
.district__no__match,
.campus__no__match {
  margin-left: 1em;
}
/*# sourceMappingURL=district-campus-dropdowns.component.css.map */
